// extracted by mini-css-extract-plugin
export default {"userDetailsContainer":"UserDetails_userDetailsContainer__0ii3X","inputRow":"UserDetails_inputRow__oAV8R","buttonRow":"UserDetails_buttonRow__ADEd9"};